import { AxiosInterceptor } from "api/core/consts";

export const failedWorkOrderLogApi = {
  searchFailedWorkOrderLog: (paging, body) =>
    AxiosInterceptor.post('failedWorkOrderLog/search' + paging, body),
  createFailedWorkOrderLog: (body) =>
    AxiosInterceptor.post('failedWorkOrderLog', body),
};
